export {};

declare global {
	interface Window {
		bindTooltip?: (element: HTMLElement, tooltip: HTMLElement | null) => { show: () => void; hide: () => void } | undefined;
	}
}
const selectors = {
	benefits: '.benefits--compact',
	benefitItem: '.benefit',
	benefitTooltip: '.tooltip',
	benefitIcon: '.benefit__icon',
};

// Only load logo logos when they are in the user's field of vision.
const benefitsObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		const benefitContainer = entry.target;
		if (entry.isIntersecting) {
			benefitContainer.querySelectorAll<HTMLElement>(selectors.benefitIcon).forEach((icon) => {
				const maskImage = icon.getAttribute('data-mask-img');

				if (maskImage) {
					icon.style.setProperty('--mask-img-url', `url(${maskImage})`);
					icon.closest(selectors.benefitItem)?.setAttribute('data-loaded', 'true');
				}
			});

			observer.unobserve(benefitContainer);
		}
	});
});

const benefitContainers = document.querySelectorAll(selectors.benefits);
if (benefitContainers.length) {
	benefitContainers.forEach((container) => {
		container.querySelectorAll<HTMLElement>(selectors.benefitItem).forEach((benefit) => {
			window.bindTooltip?.(benefit, benefit.querySelector<HTMLElement>(selectors.benefitTooltip));
		});
	});
	benefitContainers.forEach((element) => benefitsObserver.observe(element));
}
